'use client'

import { SegmentError } from '../../../_error-boundaries/segment-error.client'

type ExperienceDetailErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function ExperienceDetailError(props: ExperienceDetailErrorProps) {
  return <SegmentError boundary="experience-detail" {...props} />
}
